var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M57.1 78.3h52.2M57.1 90h52.2M57.1 101.6h52.2M121.8 53.6V36.3l-18.4-16.9H47.7c-2 0-3.6 1.6-3.6 3.6v92c0 2 1.6 3.6 3.6 3.6h70.5c2 0 3.6-1.6 3.6-3.6V53.7zM39.5 26.6H35c-2 0-3.6 1.6-3.6 3.6v77.5c0 2 1.6 3.6 3.6 3.6h4.5M26.9 33.9h-2.1c-2 0-3.6 1.6-3.6 3.6v63c0 2 1.6 3.6 3.6 3.6h2.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M103.4 19.4v16.8h18.4M60.1 38.4H66M77.9 38.5h5.9M77.9 54.1h5.9M77.9 58.1h5.9M63.1 41.3v-5.9M60.7 58.1l4.2-4.1M64.9 58.1L60.7 54M72 33.2v28M85.7 47.2h-29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatStatement);
export default __webpack_public_path__ + "static/media/VatStatement.d7f9283fa67738ee2a1d406efd62d152.svg";
export { ForwardRef as ReactComponent };